import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'configuration.title',
    defaultMessage: 'Configurations',
  },
  updatePhoto: {
    id: 'configuration.updatePhoto',
    defaultMessage: 'Update Photo',
  },
  firstName: {
    id: 'configuration.firstName',
    defaultMessage: 'First Name',
  },
  lastName: {
    id: 'configuration.lastName',
    defaultMessage: 'Last Name',
  },
  email: {
    id: 'configuration.email',
    defaultMessage: 'Email',
  },
  password: {
    id: 'configuration.password',
    defaultMessage: 'Password',
  },
  resetPassword: {
    id: 'configuration.resetPassword',
    defaultMessage: 'Reset password',
  },
  myData: {
    id: 'configuration.myData',
    defaultMessage: 'My data',
  },
  school: {
    id: 'configuration.school',
    defaultMessage: 'School',
  },
  errorRequired: {
    id: 'login.error.required',
    defaultMessage: 'Required field.',
  },
  errorInvalidEmail: {
    id: 'login.error.invalidEmail',
    defaultMessage: 'Invalid email.',
  },
  olderPassword: {
    id: "configuration.olderPassword",
    defaultMessage: "Older Password"
  },
  newPassword: {
    id: "configuration.newPassword",
    defaultMessage: "New Password"
  },
  confirmNewPassword: {
    id: "configuration.confirmNewPassword",
    defaultMessage: "Confirm New Password"
  },
  save: {
    id: "configuration.save",
    defaultMessage: "Save"
  },
  cancel: {
    id: "configuration.cancel",
    defaultMessage: "Cancel"
  },
  edit: {
    id: "configuration.edit",
    defaultMessage: "Edit"
  },
  passwordNotEqual: {
    id: "configuration.passwordNotEqual",
    defaultMessage: "Password cannot be the same as the previous one"
  },
  confirmedEditConfig: {
    id: "configuration.confirmedEditConfig",
    defaultMessage: "User info updated with success"
  },
  error44: {
    id: "configuration.error44",
    defaultMessage: "This user comes from CI"
  },
  error5: {
    id: "configuration.error5",
    defaultMessage: "User not found"
  },
  error48: {
    id: "configuration.error48",
    defaultMessage: "Older password dont match"
  },
});
